import React from 'react';
import { SiteContentSmall, DesignSparklesSmall, MobileSmall, CreditCardSmall } from '@wix/wix-ui-icons-common';

export interface LaunchStepContext {
  paymentsEnabled: boolean;
}

export interface LaunchStep {
  icon: React.ReactNode;
  labelKey: string;
  descriptionKey: string;
  color?: string;
  condition?: (context: LaunchStepContext) => boolean;
}

export const LAUNCH_STEPS: LaunchStep[] = [
  {
    icon: React.createElement(SiteContentSmall),
    labelKey: 'launch_steps.updating_site_settings.label',
    descriptionKey: 'launch_steps.updating_site_settings.description',
    color: '#00C853',
  },
  {
    icon: React.createElement(DesignSparklesSmall),
    labelKey: 'launch_steps.optimizing_store.label',
    descriptionKey: 'launch_steps.optimizing_store.description',
    color: '#2196F3',
  },
  {
    icon: React.createElement(MobileSmall),
    labelKey: 'launch_steps.publishing_store.label',
    descriptionKey: 'launch_steps.publishing_store.description',
    color: '#9C27B0',
  },
  {
    icon: React.createElement(CreditCardSmall),
    labelKey: 'launch_steps.connecting_payments.label',
    descriptionKey: 'launch_steps.connecting_payments.description',
    color: '#FF9800',
    condition: (context: LaunchStepContext) => {
      return context.paymentsEnabled;
    },
  },
];
